import { FASTElement, customElement } from '@microsoft/fast-element';
import template from './template.js';
import styles from './styles.js';

@customElement({
	name: 'card-deck',
	template,
	styles
})
export class CardDeck extends FASTElement {}